<template>
  <div class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-gutter-md justify-center">
        <div class="col-12 corner">
          <q-btn color="primary" @click="toAdd" label="添加商品" icon="add" />
        </div>
        <div class="col-md-3 col-11">
          <q-select
            outlined
            v-model="queryForm.productType"
            :options="[
              { id: '0', label: '加工' },
              { id: '1', label: '色纱' },
              { id: '2', label: '胚纱' },
            ]"
            option-value="id"
            emit-value
            map-options
            label="商品类型"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-select
            outlined
            v-model="queryForm.yarnType"
            :options="yarnList"
            option-label="typeName"
            option-value="id"
            emit-value
            map-options
            label="纱支类型"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn
            label="重置"
            type="reset"
            color="primary"
            flat
            class="q-ml-sm"
          />
        </div>
      </div>
    </q-form>

    <q-table
      ref="mytable"
      title="商品信息"
      :data="tableData.list"
      :columns="columns"
      row-key="id"
      :pagination.sync="pagination"
      :loading="loading"
      @request="request"
      binary-state-sort
      separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]"
    >
      <template v-slot:body-cell-productPic="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-img
              :src="props.row.productPic"
              spinner-color="white"
              style="height: 50px; max-width: 50px"
            />
          </div>
        </q-td>
      </template>
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn
              round
              color="primary"
              size="xs"
              icon="edit"
              @click="handleEdit(props.row)"
            />
            <q-btn
              round
              color="deep-orange"
              size="xs"
              icon="delete_forever"
              @click="remove(props.row)"
            />
          </div>
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script>
import { list, remove } from "@/api/mp/product";
import { list as listYarn } from "@/api/erp/yarn";
export default {
  data() {
    return {
      yarnList: [],
      queryForm: {},
      tableData: {},
      loading: false,
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "productPic",
          align: "center",
          label: "商品图片",
          field: "productPic",
        },
        {
          name: "productName",
          align: "center",
          label: "商品名称",
          field: "productName",
        },
        {
          name: "brand",
          align: "center",
          label: "品牌",
          field: "brand",
        },
        {
          name: "yarnType",
          align: "center",
          label: "纱支类型",
          field: (row) => row.type.typeName,
        },
        {
          name: "productType",
          align: "center",
          label: "商品类型",
          field: (row) => (row.productType == "0" ? "加工" : "色纱"),
        },
        {
          name: "seq",
          align: "center",
          label: "排序",
          field: "seq",
        },
        {
          name: "price",
          align: "center",
          label: "基础加工费",
          field: (row) => row.price + "元/" + row.unit,
          sortable: true,
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },
  methods: {
    listYarn() {
      var self = this;
      listYarn().then((response) => {
        self.yarnList = response.data.data;
      });
    },
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      list(self.queryForm).then(function (response) {
        self.tableData = response.data.data;
        self.pagination.rowsNumber = self.tableData.total;
        // don't forget to update local pagination object
        self.pagination.page = page;
        self.pagination.rowsPerPage = rowsPerPage;
        self.pagination.sortBy = sortBy;
        self.pagination.descending = descending;
        // ...and turn of loading indicator
        self.loading = false;
      });
    },
    toAdd() {
      this.$router.push("/mp/product/detail");
    },
    handleEdit(row) {
      this.$router.push({ path: "/mp/product/detail", query: { id: row.id } });
    },
    remove(row) {
      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "是否确认删除此商品?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          var self = this;
          remove(row.id).then(() => {
            self.visible = false;
            self.$q.notify({ type: "positive", message: "删除成功" });
            self.query();
          });
        })
        .onCancel(() => {})
        .onDismiss(() => {});
    },
  },
  mounted() {
    this.query();
    this.listYarn();
  },
};
</script>

<style scoped>
.corner {
  flex-direction: row-reverse;
  display: flex;
}
#queryForm {
  /* margin-top: 20px; */
  margin-bottom: 20px;
}
</style>